function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.25 5.775V3.5C8.25 3.1 8.4 2.75 8.7 2.45C9 2.15 9.35 2 9.75 2H14.25C14.65 2 15 2.15 15.3 2.45C15.6 2.75 15.75 3.1 15.75 3.5V5.775H20.5C20.9 5.775 21.25 5.925 21.55 6.225C21.85 6.525 22 6.875 22 7.275V19.5C22 19.9 21.85 20.25 21.55 20.55C21.25 20.85 20.9 21 20.5 21H3.5C3.1 21 2.75 20.85 2.45 20.55C2.15 20.25 2 19.9 2 19.5V7.275C2 6.875 2.15 6.525 2.45 6.225C2.75 5.925 3.1 5.775 3.5 5.775H8.25ZM9.75 5.775H14.25V3.5H9.75V5.775ZM20.5 14.725H14.275V16.225H9.775V14.725H3.5V19.5H20.5V14.725ZM11.275 14.725H12.775V13.225H11.275V14.725ZM3.5 13.225H9.775V11.725H14.275V13.225H20.5V7.275H3.5V13.225Z",
  fill: "black"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/luggage-xs.8632c016.svg";
export { SvgComponent as ReactComponent };